import React from 'react';
import {View} from 'react-native';
import {Breadcrumbs} from '../../shared/components/breadcrumbs';
import {LoadableContent} from '../../shared/components/loadableContent';
import {ResponsiveView} from '../../shared/components/responsiveView';
import Screen from '../../shared/components/screen';
import {CustomScrollView} from '../../shared/components/scrollView';
import {Text} from '../../shared/components/text';
import {useStyles} from '../../shared/hooks/styles';
import {CardIssuer} from '../../shared/models/api';
import {Routes, Screens} from '../../shared/routing';
import {DeviceSize} from '../../shared/theme/helpers';
import {FinancialTransportService} from './financialTransportService';
import {Props} from './model';
import {NonFinancialTransportService} from './nonFinancialTransportService';

const routes = [
  {
    title: 'Возможности карты',
    routeName: Screens.CardServices,
    webRoute: Routes.cardService,
  },
  {
    title: 'Транспортное приложение',
    routeName: Screens.TransportService,
    webRoute: Routes.transportService,
  },
];

export default ({cardIssuer}: Props) => {
  const styles = useStyles(({theme, deviceSize, mediaOnly}) => {
    return {
      screen: {
        backgroundColor: theme.screen.container[deviceSize].backgroundColor,
      },
      sectionTitle: {
        ...theme.fonts.h2,
        marginBottom: 30,
        marginTop: 40,
      },
      sectionContainer: {
        overflow: 'hidden',
        marginTop: 32,
        ...mediaOnly(DeviceSize.desktop, {paddingHorizontal: 24}, {paddingHorizontal: 16}),
      },
    };
  });

  const TransportView = cardIssuer === CardIssuer.SkbBank ? FinancialTransportService : NonFinancialTransportService;

  return (
    <Screen style={styles.screen}>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <View style={styles.sectionContainer}>
          <Breadcrumbs style={{flex: undefined}} routes={routes} />
          <ResponsiveView only={[DeviceSize.desktop]}>
            <Text testID='transport-app-id' style={styles.sectionTitle}>
              Транспортное приложение
            </Text>
          </ResponsiveView>
          <LoadableContent loading={!cardIssuer}>
            <TransportView />
          </LoadableContent>
        </View>
      </CustomScrollView>
    </Screen>
  );
};
